export default "__VITE_ASSET__7781b9fd__"